import { createFileRoute } from '@tanstack/react-router'

import { IntegrationsPage } from '#/modules/system/integrations-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/integrations')({
  component: IntegrationsPage,
  validateSearch: validateListSearch,
})
